<template>
  <el-submenu
    v-if="item[fieldMap.children] && item[fieldMap.children].length"
    :index="item[fieldMap.id]"
  >
    <template slot="title">
      <i :class="picon"></i>
      <span>{{ item[fieldMap.title] }}</span>
    </template>
    <menu-item
      v-for="child in item[fieldMap.children]"
      :key="child[fieldMap.id]"
      :item="child"
      :picon="picon"
      :cicon="cicon"
      :field-map="fieldMap"
      @click="$emit('click', $event)"
    />
  </el-submenu>
  <el-menu-item v-else :index="item[fieldMap.id]" @click="$emit('click', item)">
    <i :class="cicon"></i>
    <span slot="title">{{ item[fieldMap.title] }}</span>
  </el-menu-item>
</template>

<script>
export default {
  name: "MenuItem",
  props: {
    item: {
      type: Object,
      required: true,
    },
    picon: {
      type: String,
      default: "el-icon-s-grid",
    },
    cicon: {
      type: String,
      default: "el-icon-menu",
    },
    fieldMap: {
      type: Object,
      default: () => ({
        id: "Id",
        title: "title",
        children: "children",
      }),
    },
  },
};
</script>

<style lang="scss" scoped></style>
